import { axiosWdw, domainEndpoint } from './axios';

const endpoint_thought = '/thought/';
const endpoint_comment = '/comment';

export default {
  get(thoughtid: number, params: any) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint_thought + thoughtid + endpoint_comment,
      params: params,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getFirst(thoughtid: number, highlight = false) {
    return this.get(thoughtid, {
      rows: 1,
      page: 1,
      highlight: highlight ? 1 : 0,
    });
  },

  getHighlighted(thoughtid: number, params?: any) {
    return this.get(thoughtid, {
      ...params,
      highlight: 1,
    });
  },

  getRows(thoughtid: number, rows: number, params?: any) {
    return this.get(thoughtid, {
      ...params,
      rows: rows,
      page: 1,
      highlight: 0,
    });
  },

  put(topicid: number, thoughtid: number, data: object) {
    const set_url = domainEndpoint() + '/topic/' + topicid + endpoint_thought + thoughtid + '/set_comment';
    return axiosWdw({
      method: 'PUT',
      url: set_url,
      data: data,
    })
      .then(response => {
        if (response && response.data.success) {
          console.log('set_comment response', response.data.data);
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  create(thoughtid: number, data: object, files: Map<string, any>) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(data));
      files?.forEach((value, key) => {
        formdata.append(key, value);
      });

      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint_thought + thoughtid + '/comment',
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  update(thoughtid: number, commentid: number, data: object, files: Map<string, any>) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(data));
      files?.forEach((value, key) => {
        formdata.append(key, value);
      });

      axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint_thought + thoughtid + '/comment/' + commentid,
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  supportComment(commentid: number) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint_comment + '/' + commentid + '/support',
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
};
